<script setup lang="ts">
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area'
import { Stepper, StepperIndicator, StepperItem, StepperTitle } from '@/components/ui/stepper'
import { Check } from 'lucide-vue-next'

interface Step {
    name: string
    state: 'completed' | 'active' | 'inactive'
}

defineProps<{
    steps: Step[]
}>()
</script>

<template>
    <div class="flex items-center overflow-hidden md:overflow-visible">
        <ScrollArea type="scroll" class="w-96 whitespace-nowrap md:w-full">
            <Stepper class="border-t bg-transparent pt-8 md:mt-0 md:border-t-0 md:border-l md:pt-0 md:pl-6">
                <StepperItem
                    v-for="(step, index) in steps"
                    :key="step.name"
                    :data-state="step.state"
                    class="flex w-fit first:pl-0 lg:px-2"
                    :step="index + 1"
                >
                    <StepperIndicator
                        class="group-data-[state=completed]:bg-primary group-data-[state=active]:bg-tranparent group-data-[state=active]:border-primary group-data-[state=active]:text-primary h-[40px] w-[40px] group-data-[state=active]:border group-data-[state=active]:border-dashed group-data-[state=completed]:text-white group-data-[state=inactive]:border"
                    >
                        <Check v-if="step.state === 'completed'" />
                        <span v-if="step.state != 'completed'">{{ String(index + 1).padStart(2, '0') }}</span>
                    </StepperIndicator>
                    <StepperTitle
                        class="group-data-[state=active]:text-primary text-sm font-medium text-gray-900 group-data-[state=inactive]:text-slate-400"
                    >
                        {{ step.name }}
                    </StepperTitle>
                </StepperItem>
            </Stepper>
            <ScrollBar orientation="horizontal" />
        </ScrollArea>
    </div>
</template>
